// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leftBg {\n  background: var(--left-image);\n  flex: 0 0 fit-content;\n  background-size: contain;\n}\n.leftBg img {\n  opacity: 0;\n  height: 100vh;\n}", ""]);
// Exports
module.exports = exports;
